export default {
  data() {
    return {
      /**电子处方 */
      tabsListL3: [
        {
          label: '全部',
          name: '0',
        },
        {
          label: '未购买',
          name: '1',
        },
        {
          label: '已购买',
          name: '2',
        },
        {
          label: '已失效',
          name: '3',
        },
      ],
      /**电子处方平台端 */
      tabListL3Config: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          size: 'mini',
          width: '50px',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>
          },
        },
        {
          label: '处方ID',
          align: 'center',
          prop: 'no',
          size: 'mini',
          showOverflowTooltip:true
        },
        {
          label: '处方类型',
          align: 'center', //缺少
          prop: 'type',
          size: 'mini',
          enumType: 'prescription',
        },
        {
            label:'病人',
            align :'center',
            prop:"patientName" ,  
            width:'120px',
            render: (h, scope) => {
              return <span slot="reference">{!scope.row.logOff ? scope.row.patientName :scope.row.patientName + '(已注销)'} </span>
            },
        },
        {
            label:'病人类型',
            align :'center',
            prop:"serviceSourceCode" ,
            size:'mini',
            render: (h, scope) => {
              return <span slot="reference"> {scope.row.serviceSourceCode == 1 ? '全病程' : '互联网医院'} </span>
            },
        },
        // {
        //     label:'病种',
        //     align :'center',
        //     prop:"diseasesType1" ,
        //     size:'mini'
        // },
        {
          label: '医生',
          align: 'center',
          prop: 'prescriberName',
          size: 'mini',
        },
        {
          label: '线下机构',
          align: 'center',
          prop: 'hospitalName',
          size: 'mini',
          showOverflowTooltip:true

        },
        {
          label: '互医机构',
          align: 'center',
          prop: 'platformName',
          size: 'mini',
          showOverflowTooltip:true

        },
        {
          label: '创建时间',
          align: 'center',
          prop: 'createTime',
          size: 'mini',
          showOverflowTooltip:true

        },
        {
          label: '初步诊断',
          align: 'center',
          prop: 'initDiagnosis',
          size: 'mini',
          showOverflowTooltip:true
        },
        // {
        //   label: '诊后建议',
        //   align: 'center',
        //   prop: 'handleOpinion', 
        //   size: 'mini',
        //   showOverflowTooltip:true
        // },
        {
          label: '审核药师',
          align: 'center',
          prop: 'examinerName',
          size: 'mini',
		  render: (h, scope) => {
		    return <span>{scope.row.examinerName ? scope.row.examinerName :'--'}
		     </span>
		  },
        },
        {
          label: '审核时间',
          align: 'center',
          prop: 'examineTime',
          size: 'mini',
		  render: (h, scope) => {
		    return <span>{scope.row.examineTime ? scope.row.examineTime :'--'}
		     </span>
		  },
        },
        {
          label: '审核状态',
          align: 'center',
          prop: 'status',
          size: 'mini',
          render: (h, scope) => {
            return <span>{
                scope.row.status == 1 ? '待审核' : 
                scope.row.status == 2 ? '审核通过' : 
                scope.row.status == 3 ? '审核驳回' : '审核过期'}
             </span>
          },
        },
		{
		  label: '审核标签',
		  align: 'center',
		  size: 'mini',
		  render: (h, scope) => {
		    return <span>{
		        scope.row.approvalTimeout||scope.row.remindApproval?((scope.row.approvalTimeout ? '超时' : '') + (scope.row.approvalTimeout&&scope.row.remindApproval?',':'')+
		        (scope.row.remindApproval ? '催审' : '')):'--'}
		     </span>
		  },
		},
        {
          label: '失效倒计时',
          width:'100px',
          align: 'center',
          size: 'mini',
          render:(h,scope) =>{
            return <span slot="reference">
              {scope.row.invalidRemainDays ? scope.row.invalidRemainDays + "天" : '--'}
            </span>
          }
        },
        {
          label: '购药状态',
          align: 'center',
          prop: 'purchaseStatus',
          size: 'mini',
          render: (h, scope) => {
            return <span>{
              scope.row.purchaseStatus == 1 ? '未购买' : 
              scope.row.purchaseStatus == 2 ? '已购买' : 
              scope.row.purchaseStatus == 3 ? '已失效' : 
              scope.row.purchaseStatus == 4 ? '已取消购买' :  '未知'}
            </span>
          },
        },
        {
          label: '购药时间',
          align: 'center', 
          prop: 'purchaseTime',
          size: 'mini',
          showOverflowTooltip:true,
		  render:(h,scope) =>{
		    return <span slot="reference">
		      {scope.row.purchaseTime ? scope.row.purchaseTime  : '--'}
		    </span>
		  }
		  
        },
        {
          label: '操作',
          align: 'center',
          width: '150px',
          fixed:'right',
          render: (h, scope) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.hometHandel(scope, 'details')
                    },
                  },
                },
                '详情'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  attrs: {
                    style: (scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5) ? 'display:none' : '',
					display:(scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5) ? 'none' : 'inline-block'
                  },
                  on: {
                    click: () => {
                      this.reminderHandel(scope.row)
                    },
                  },
                },
                '提醒'
              ),
			  h(
			    'el-button',
			    {
			      props: { type: 'text', size: 'mini' },
			      attrs: {
					style: (scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5) ? 'display:none' : '',
			        disabled: scope.row.status != 1 || scope.row.remindApproval ? true : false,
					
					
			      },
			      on: {
			        click: () => {
			          this.remindApprovalHandel(scope.row)
			        },
			      },
			    },
			    '催审'
			  ),
            ])
          },
        },
      ],
      /**电子处方机构端 */
      tabListL3Config1: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          size: 'mini',
          width: '50px',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>
          },
        },
        {
          label: '处方ID',
          align: 'center',
          prop: 'no',
          size: 'mini',
          showOverflowTooltip:true
        },
        {
          label: '处方类型',
          align: 'center', //缺少
          prop: 'type',
          size: 'mini',
          enumType: 'prescription',
        },
        {
            label:'病人',
            align :'center',
            prop:"patientName", 
            width:'120px',
            render: (h, scope) => {
              return <span slot="reference">{!scope.row.logOff ? scope.row.patientName :scope.row.patientName + '(已注销)'} </span>
            },
        },
        {
            label:'病人类型',
            align :'center',
            prop:"serviceSourceCode" ,
            size:'mini',
            render: (h, scope) => {
              return <span slot="reference"> {scope.row.serviceSourceCode == 1 ? '全病程' : '互联网医院'} </span>
            },
        },
        {
          label: '医生',
          align: 'center',
          prop: 'prescriberName',
          size: 'mini',
        },
        {
          label: '互医机构',
          align: 'center',
          prop: 'platformName',
          size: 'mini',
          showOverflowTooltip:true

        },
        {
          label: '创建时间',
          align: 'center',
          prop: 'createTime',
          size: 'mini',
          showOverflowTooltip:true

        },
        {
          label: '初步诊断',
          align: 'center',
          prop: 'initDiagnosis',
          size: 'mini',
          showOverflowTooltip:true
        },
        {
          label: '审核药师',
          align: 'center',
          prop: 'examinerName',
          size: 'mini',
		  render: (h, scope) => {
		    return <span>{scope.row.examinerName ? scope.row.examinerName :'--'}
		     </span>
		  },
        },
        {
          label: '审核时间',
          align: 'center',
          prop: 'examineTime',
          size: 'mini',
		  render: (h, scope) => {
		    return <span>{scope.row.examineTime ? scope.row.examineTime :'--'}
		     </span>
		  },
        },
        {
          label: '审核状态',
          align: 'center',
          prop: 'status',
          size: 'mini',
          render: (h, scope) => {
            return <span>{
                scope.row.status == 1 ? '待审核' : 
                scope.row.status == 2 ? '审核通过' : 
                scope.row.status == 3 ? '审核驳回' : '审核过期'}
             </span>
          },
        },
		{
		  label: '审核标签',
		  align: 'center',
		  size: 'mini',
		  render: (h, scope) => {
		    return <span>{
		        scope.row.approvalTimeout||scope.row.remindApproval?((scope.row.approvalTimeout ? '超时' : '') + (scope.row.approvalTimeout&&scope.row.remindApproval?',':'')+
		        (scope.row.remindApproval ? '催审' : '')):'--'}
		     </span>
		  },
		},
        {
          label: '失效倒计时',
          width:'100px',
          align: 'center',
          size: 'mini',
          render:(h,scope) =>{
            return <span slot="reference">
              {scope.row.invalidRemainDays ? scope.row.invalidRemainDays + "天" : '--'}
            </span>
          }
        },
        {
          label: '购药状态',
          align: 'center',
          prop: 'purchaseStatus',
          size: 'mini',
          render: (h, scope) => {
            return <span>{
              scope.row.purchaseStatus == 1 ? '未购买' : 
              scope.row.purchaseStatus == 2 ? '已购买' : 
              scope.row.purchaseStatus == 3 ? '已失效' : 
              scope.row.purchaseStatus == 4 ? '已取消购买' :  '未知'}
            </span>
          },
        },
        {
          label: '购药时间',
          align: 'center', 
          prop: 'purchaseTime',
          size: 'mini',
          showOverflowTooltip:true,
		  render:(h,scope) =>{
		    return <span slot="reference">
		      {scope.row.purchaseTime ? scope.row.purchaseTime  : '--'}
		    </span>
		  }
		  
        },
        {
          label: '操作',
          align: 'center',
          width: '150px',
          fixed:'right',
          render: (h, scope) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.hometHandel(scope, 'details')
                    },
                  },
                },
                '详情'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  attrs: {
                    style: (scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5) ? 'display:none' : '',
					display:(scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5) ? 'none' : 'inline-block'
                  },
                  on: {
                    click: () => {
                      this.reminderHandel(scope.row)
                    },
                  },
                },
                '提醒'
              ),
			  h(
			    'el-button',
			    {
			      props: { type: 'text', size: 'mini' },
			      attrs: {
					style: (scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5) ? 'display:none' : '',
			        disabled: scope.row.status != 1 || scope.row.remindApproval ? true : false,
					
					
			      },
			      on: {
			        click: () => {
			          this.remindApprovalHandel(scope.row)
			        },
			      },
			    },
			    '催审'
			  ),
            ])
          },
        },
      ],
      /**处方表格 */
      prescriptionConfig: [
        {
          label: '序号',
          align: 'center',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>
          },
        },
        {
          label: '药品名称',
          align: 'center',
          prop: 'drugName',
          size: 'mini',
          showOverflowTooltip:true,
        },
        {
          label: '用法用量',
          align: 'center',
          // prop:"medicationMode" ,
          size: 'mini',
          showOverflowTooltip:true,
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.medicationFrequency == 1 ? '每日一次' : scope.row.medicationFrequency == 2 ? '每日两次' : scope.row.medicationFrequency == 3 ? '每日三次' : scope.row.medicationFrequency == 4 ? '隔天一次' : scope.row.medicationFrequency == 5 ? '每周两次' : '未知'},
                {scope.row.medicationNumber}
                {scope.row.medicationUnit == 1 ? '片/次' : scope.row.medicationUnit == 2 ? '粒/次' : scope.row.medicationUnit == 3 ? '袋/次' : scope.row.medicationUnit == 4 ? '支/次' : scope.row.medicationUnit == 5 ? '丸/次' : '未知'},
                {scope.row.medicationMode == 1 ? '口服' : scope.row.medicationMode == 2 ? '外用' : scope.row.medicationMode == 3 ? '舌下' : scope.row.medicationMode == 4 ? '含服' : scope.row.medicationMode == 5 ? '喷鼻' : '未知'}
              </span>
            )
          },
        },
        {
          label: '疗程周期',
          align: 'center',
          prop: 'treatmentCycle',
          size: 'mini',
          showOverflowTooltip:true,
          render: (h, scope) => {
            return <span slot="reference">{scope.row.treatmentCycle + (scope.row.treatmentCycleUnit == 1 ? '天' : '周')}</span>
          },
        },
      ],
      serviceList: [
        {
          label: '全病程',
          value: 1,
        },
        {
          label: '互联网医院',
          value: 2,
        },
      ],
      consultationTypeConfig: [
        {
          label: '西药处方',
          value: 1,
        },
        {
          label: '中药处方',
          value: 2,
        },
        {
          label: '营养处方',
          value: 3,
        },
        {
          label: '运动处方',
          value: 4,
        },
        {
          label: '治疗处方',
          value: 5,
        },
      ],
      staticConfig: [
        {
          label: '待审核',
          value: 1,
        },
        {
          label: '审核通过',
          value: 2,
        },
		
        {
          label: '审核驳回',
          value: 3,
        },
		{
			label:'审核过期',
			value: 4
		},
      ],
      orderTypeConfig: [
        {
          label: '全病程',
          value: 1,
        },
        {
          label: '药品',
          value: 2,
        },
        {
          label: '问诊',
          value: 3,
        },
      ],
    }
  },
}
